module.exports = __webpack_public_path__ + "eb6b9b52c2c29965f92d953b891c4787.svg";